(function () {
  function closeDialog(dialog) {
    if (!dialog || typeof dialog.close !== 'function') return;
    dialog.close();
  }

  function openDialog(dialog) {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (!dialog.open) dialog.showModal();
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-andala-results-open]');
    if (openTrigger) {
      var dialogId = openTrigger.getAttribute('data-andala-results-open');
      var dialog = dialogId ? document.getElementById(dialogId) : null;
      if (dialog) {
        event.preventDefault();
        openDialog(dialog);
      }
      return;
    }

    var closeTrigger = event.target.closest('[data-andala-results-close]');
    if (closeTrigger) {
      var dialogToClose = closeTrigger.closest('dialog');
      if (dialogToClose) {
        event.preventDefault();
        closeDialog(dialogToClose);
      }
    }
  });

  document.addEventListener('click', function (event) {
    var dialog = event.target;
    if (dialog && dialog.tagName === 'DIALOG' && dialog.classList.contains('andala-results__dialog')) {
      var rect = dialog.getBoundingClientRect();
      var clickedInDialog =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!clickedInDialog) closeDialog(dialog);
    }
  });
})();
